import React from 'react';

export const CloseIcon: React.FC = () => (
	<svg width='1.3rem' height='1.4rem' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M0.807617 12.5L12 1.30763' stroke='currentColor' strokeWidth='1.5' />
		<path d='M12 12.5L0.807626 1.30763' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
